import React, { ImgHTMLAttributes } from 'react';

import { ImageWithZoom } from 'modules/UI';

import { A, H1, H2, H3, H4, H5, H6, Li, Ol, P, Table, Tbody, Td, Th, Thead, Tr, Ul } from './styles';

export const p: React.FC = (props) => <P {...props} />;

export const h1: React.FC = (props) => <H1 {...props} />;

export const h2: React.FC = (props) => <H2 {...props} />;

export const h3: React.FC = (props) => <H3 {...props} />;

export const h4: React.FC = (props) => <H4 {...props} />;

export const h5: React.FC = (props) => <H5 {...props} />;

export const h6: React.FC = (props) => <H6 {...props} />;

export const a: React.FC = (props) => <A dataTestId="mdx-link" {...props} />;

export const ul: React.FC = (props) => <Ul {...props} />;

export const ol: React.FC = (props) => <Ol {...props} />;

export const li: React.FC = (props) => <Li {...props} />;

export const table: React.FC = (props) => <Table {...props} />;

export const thead: React.FC = (props) => <Thead {...props} />;

export const tbody: React.FC = (props) => <Tbody {...props} />;

export const tr: React.FC = (props) => <Tr {...props} />;

export const td: React.FC = (props) => <Td {...props} />;

export const th: React.FC = (props) => <Th {...props} />;

export const img: React.FC<ImgHTMLAttributes<HTMLImageElement>> = (props) => (
  <ImageWithZoom src={props.src} alt={props.alt} {...props} />
);

// TODO::
// thematicBreak,
// blockquote,
// pre,
// code,
// em,
// strong,
// delete,
// inlineCode,
// hr,
